module.exports = __webpack_public_path__ + "static/media/No-vehicle.a87d97ec.png";